import requester from '@/lib/axios';
import { QuizActivityElement } from '@/models/_deprecated/ActivityElement';
import { QuizQuestion } from '@/models/ActivityProgress';

export const getQuizActivity = async (questionId: number) => {
  const { data: quiz } = await requester().get<QuizActivityElement>(
    `quiz-activity/${questionId}/`,
  );
  return quiz;
};

type CreateQuizPayload = Omit<QuizActivityElement, 'id' | 'quizAnswers'>;

export const createQuizActivity = async (quiz: CreateQuizPayload) => {
  const { data: newQuiz } = await requester().post<QuizActivityElement>(
    `quiz-activity/`,
    quiz,
  );
  return newQuiz;
};

export const deleteQuizActivity = async (questionId: number) => {
  await requester().delete<QuizActivityElement>(`quiz-activity/${questionId}/`);
};

export const updateQuizActivity = async (
  quizId: number,
  quiz: Partial<QuizActivityElement>,
) => {
  const { data: newQuiz } = await requester().patch<QuizActivityElement>(
    `quiz-activity/${quizId}/`,
    quiz,
  );
  return newQuiz;
};

type QuizAnswePayload = Pick<QuizAnswer, 'isCorrect' | 'answer'> & {
  quiz: number;
};

export type QuizAnswer = QuizQuestion & {
  isCorrect: boolean;
};

export const createQuizAnswer = async (quizAnswer: QuizAnswePayload) => {
  const { data: newQuizAnswer } = await requester().post<QuizAnswer>(
    'text-quiz-answer/',
    quizAnswer,
  );
  return newQuizAnswer;
};

export const updateQuizAnswer = async (
  quizAnswerId: number,
  quizAnswer: Partial<QuizAnswer>,
) => {
  const { data: newQuizAnswer } = await requester().patch<QuizAnswer>(
    `text-quiz-answer/${quizAnswerId}/`,
    quizAnswer,
  );
  return newQuizAnswer;
};

export const deleteQuizAnswer = async (quizAnswerId: number) => {
  await requester().delete<QuizAnswer>(`text-quiz-answer/${quizAnswerId}/`);
};
